import type { RatingsSnapshot } from '@/api/ratings';

/**
 * Construction des chips ratings affichés dans FixedNav (header Mission Control).
 *
 * Logique extraite de `MissionControlPage.tsx` pour respecter
 * `react-refresh/only-export-components` (pattern PR #125 / planMapping.ts)
 * et permettre les tests unitaires (T7 P1 Stats Hub).
 *
 * Hiérarchie ROADMAP §233 (T7) : **FIDE → Lichess → chess.com**.
 * Cadence Rapide partout, fallback Classique si Rapide absent côté Lichess.
 * Format unifié `[Plateforme] [Cadence]` `[Valeur]`. Couleurs alignées sur
 * `<RatingBadge>` : FIDE = paper-50, Lichess = violet-500, chess.com = amber-500.
 */

export interface NavChip {
  label: string;
  value: string;
  color?: string;
}

export function buildNavChips(snapshot: RatingsSnapshot | undefined): NavChip[] {
  const chips: NavChip[] = [];
  if (!snapshot) return chips;

  const fideRapide = snapshot.fide?.rapide?.value ?? null;
  if (fideRapide != null) {
    chips.push({ label: 'FIDE Rapide', value: String(fideRapide), color: 'var(--paper-50)' });
  }

  const lichessRapid =
    snapshot.lichess?.rapid?.value ?? snapshot.lichess?.classical?.value ?? null;
  if (lichessRapid != null) {
    chips.push({ label: 'Lichess Rapide', value: String(lichessRapid), color: 'var(--violet-500)' });
  }

  const ccRapid = snapshot.chesscom?.rapid?.value ?? null;
  if (ccRapid != null) {
    chips.push({ label: 'chess.com Rapide', value: String(ccRapid), color: 'var(--amber-500)' });
  }

  return chips;
}
